import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-report-footer',
  templateUrl: './report-footer.component.html'
})
export class ReportFooterComponent {
  @Input() today: Date = new Date();
  @Output() download = new EventEmitter<void>();
  @Output() recalculate = new EventEmitter<void>();
}
